import { render } from "./ProfileTeachersComments.vue?vue&type=template&id=64d727fc&scoped=true"
import script from "./ProfileTeachersComments.vue?vue&type=script&lang=js"
export * from "./ProfileTeachersComments.vue?vue&type=script&lang=js"

import "./ProfileTeachersComments.vue?vue&type=style&index=0&id=64d727fc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64d727fc"]])

export default __exports__